module.exports = __webpack_public_path__ + "img/img_polaroid_sleepgirl@3x.bc5f0fdf.png";